import { SUBSCRIPTION_STATUS } from '@/lib/api/subscriptions/types';

interface PlatformSubscription {
    status: number;
    data?: {
        subscription_tier?: string;
        price?: {
            interval?: string;
        };
    };
    valid_until?: number | null;
}

/**
 * Get the billing cycle text based on subscription status and interval
 */
export function getBillingCycle(subscription: PlatformSubscription | null | undefined): string {
    const currentStatus = subscription?.status ?? -1;

    switch (currentStatus) {
        case SUBSCRIPTION_STATUS.CANCELLED:
            return 'Cancelled';
        case SUBSCRIPTION_STATUS.ACTIVE:
        case SUBSCRIPTION_STATUS.DOWNGRADED:
            return subscription?.data?.price?.interval === 'year' ? 'Billed Annually' : 'Billed Monthly';
        case SUBSCRIPTION_STATUS.PENDING_ASSISTANCE:
        default:
            return 'Pending Assistance';
    }
}

/**
 * Get the next billing date information text
 */
export function getNextBillDateInformation(nextBillingDate: number | null | undefined): string | undefined {
    if (!nextBillingDate) {
        return undefined;
    }

    const date = new Date(nextBillingDate * 1000);

    return `Your next payment is on ${date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    })}`;
}
